import { Component, OnInit, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxLoadIndicatorModule } from 'devextreme-angular';

@Component({
  selector: 'app-rx-item-card',
  templateUrl: './rx-item-card.component.html',
  styleUrls: ['./rx-item-card.component.scss'],
})
export class RxItemCardComponent implements OnInit {
  @Input() details: any;
  @Input() type: any = 'wc';

  constructor() {}

  ngOnInit() {}
}

@NgModule({
  imports: [CommonModule, DxLoadIndicatorModule],
  declarations: [RxItemCardComponent],
  exports: [RxItemCardComponent],
})
export class RxItemCardModule {}
